export default __webpack_public_path__ + "static/ASLA_Tonyo_2-ab229136a02960d788d56309796efac1.png";